import axios from 'axios';
import i18n from 'roddeh-i18n';
import { dispatch, } from './social-auth';
/** Przycisk, dla którego wykonano inicjalizację logowania */
let logInButton = null;
/** Wyświetl błąd autoryzacji użytkownikowi */
const showErrors = (data) => {
    let error;
    if (typeof data.message === 'undefined') {
        error = i18n('An unknown error occurred. Please try again later');
    }
    else {
        error = data.message;
    }
    const errorModal = document.createElement('tc-modal');
    errorModal.innerHTML = error;
    document.body.append(errorModal);
    errorModal.open();
};
const handleSuccessAuth = (response) => {
    const { id_token, code } = response.authorization;
    let firstName = null;
    let lastName = null;
    if (response.user) {
        firstName = response.user.name.firstName;
        lastName = response.user.name.lastName;
    }
    axios
        .post('/apple/tokensignin', { token: id_token, code: code, first_name: firstName, last_name: lastName })
        .then((response) => {
        if (!response.data.logged && response.data.email) {
            let firstName = '';
            let lastName = '';
            if (response.data.first_name) {
                firstName = response.data.first_name;
            }
            if (response.data.last_name) {
                lastName = response.data.last_name;
            }
            dispatch('signed', {
                type: 'account_created',
                source: 'Apple',
                firstName: firstName,
                lastName: lastName,
                email: response.data.email,
            }, logInButton);
        }
        else {
            if (response.data.logged) {
                const data = {
                    type: 'logged',
                    firstName: response.data.first_name,
                    lastName: response.data.last_name,
                };
                if (typeof response.data.redirect_to !== 'undefined') {
                    data.redirectTo = response.data.redirect_to;
                }
                dispatch('signed', data, logInButton);
            }
            else {
                console.error('Received success response that was not logged or registration');
                showErrors({});
                dispatch('canceled', {}, logInButton);
            }
        }
    })
        .catch((err) => {
        console.error('/apple/tokensignin failure', err);
        const data = {};
        if (typeof err.response !== 'undefined') {
            if (typeof err.response.data.message !== 'undefined') {
                data.message = err.response.data.message;
            }
            if (typeof err.response.data.errors !== 'undefined') {
                data.errors = err.response.data.errors;
            }
        }
        showErrors(data);
        dispatch('canceled', data, logInButton);
    });
};
/** Inicjalizacja modułu po jego załadowaniu */
const init = () => {
    const button = document.querySelector('#appleid-signin');
    if (button) {
        logInButton = button;
    }
    const clientID = window.__STATE__?.functions.apple_auth_client_id;
    if (clientID === null || typeof clientID === 'undefined') {
        console.error('Tried to initialize Sign with Apple but client id was not found in __STATE__');
        return;
    }
    const serverUrl = window.__STATE__?.system.server_url;
    if (typeof serverUrl === 'undefined') {
        console.error('Missing server url in __STATE__');
        return;
    }
    AppleID.auth.init({
        clientId: clientID,
        scope: 'name email',
        redirectURI: serverUrl + '/auth',
        usePopup: true,
    });
    document.addEventListener('AppleIDSignInOnSuccess', (e) => {
        handleSuccessAuth(e.detail);
    });
};
export default () => {
    if (document.readyState === 'complete') {
        init();
    }
    else {
        window.addEventListener('load', () => {
            init();
        });
    }
};
